import { Checkbox } from "@shared/ui/checkbox";
import { AlertCircle, CheckCircle2, HelpCircle } from "lucide-react";
import React from "react";

interface LatePaymentPenaltyProps {
  lateFee: number;
  currency: string;
  isWaived: boolean;
  onWaiveToggle: (waived: boolean) => void;
}

export const LatePaymentPenalty: React.FC<LatePaymentPenaltyProps> = ({
  lateFee,
  currency,
  isWaived,
  onWaiveToggle,
}) => {
  return (
    <div className="bg-[#fff5f5] border border-red-200/60 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <AlertCircle className="w-[18px] h-[18px] text-red-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h4 className="font-bold text-red-600 text-[13px] mb-3">
            Late Payment Penalty Applicable
          </h4>
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-1.5 mb-1">
                <span className="text-[11px] text-gray-500">
                  Late Fee (5% of outstanding)
                </span>
                <HelpCircle className="w-3.5 h-3.5 text-gray-400" />
              </div>
              <div className="flex items-center gap-2">
                <p
                  className={`text-[16px] font-bold ${
                    isWaived ? "line-through text-gray-400" : "text-red-600"
                  }`}
                >
                  {currency} {lateFee.toFixed(2)}
                </p>
                {isWaived && (
                  <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-full text-[11px] font-medium">
                    Waived
                  </span>
                )}
              </div>
              {isWaived && (
                <div className="flex items-center gap-1.5 mt-2 text-green-700">
                  <CheckCircle2 className="w-4 h-4" />
                  <span className="text-[12px] font-medium">
                    Late fee has been waived. Total amount updated.
                  </span>
                </div>
              )}
            </div>
            <div className="flex items-center">
              <label className="flex items-center gap-2 cursor-pointer bg-white border border-gray-200 rounded-md px-3 py-1.5 shadow-sm hover:bg-gray-50 transition-colors">
                <Checkbox
                  checked={isWaived}
                  onCheckedChange={(checked) =>
                    onWaiveToggle(checked as boolean)
                  }
                  className="w-4 h-4 border-gray-300"
                />
                <span className="text-[12px] font-medium text-gray-700">
                  Waive Late Fee
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
